steal("foo", "bar", function(foo, bar){
	return {
		foo: foo,
		bar: bar
	};
});
